import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import {
  IConfigurationRolesAndPermissionCreatePostBody,
  IConfigurationRolesAndPermissionCreateResponse,
} from "@/api_framework/api_modals/Configuration";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useCurlLogger } from "../../useCurlLogger";
import AxiosCurlirize from "axios-curlirize";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useConfigurationRBACCreateAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const execute = useCallback(
    async (body: IConfigurationRolesAndPermissionCreatePostBody) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        if (!body) {
          return;
        }
        const response: string = await axios
          .post(
            `${CONFIGURATION_APIS?.CREATE_ROLES_AND_PERMISSION?.baseURL}` ?? "",
            body, // Send staffCategoryData as the request body
            {
              headers: {
                Authorization: `${accessToken}`,
                "Content-Type": "application/json",
              },
            },
          )
          .then((res: AxiosResponse<IConfigurationRolesAndPermissionCreateResponse>) => {
            if (res.data.status === true) {
              toast.success("Role & Permission created successfully.");
              return res.data.data.role_id;
            } else {
              return null;
            }
          })
          .catch((e: AxiosError) => {
            captureError(e)
            sendCurl(e.config["curlCommand"]);
            return null;
          });
        return response;
      } catch (error) {
        // Handle errors
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          if (axiosError.code === "ERR_BAD_REQUEST") {
            toast.error("Error while creating roles and permissions.");
          }
          if (axiosError.response?.status === 400) {
            toast.error(axiosError.message);
          }
          if (axiosError.response?.status === 500) {
            toast.error("Internal Server Error, Contact Tech Team.");
          }
        } else {
          toast.error("Server Error: " + error.message);
        }
        return null;
      }
    },
    [configuration],
  );

  return execute;
};
